import Vue from "vue"
import VueRouter from "vue-router"
import TowerList from "@/views/TowerList"
import UserProfile from "@/views/UserProfile"
import Intent from "@/views/tower/Intent"
import SRFPlot from "@/views/tower/SRFPlot"
import Reports from "@/views/tower/Reports"
import ViewCSVReport from "@/views/tower/ViewCSVReport"
import CrudView from "@/views/CrudView"
import SignIn from "@/views/SignIn"
import { LoginCallback } from "@okta/okta-vue"

Vue.use(VueRouter);

const libraryRoutes = [
  "turbine",
  "design-basis",
  "load-set",
  "inventory",
  "material",
  "bolt",
]

const router = new VueRouter({
  mode: "history",
  routes:
    libraryRoutes.flatMap((route) => [
      {
        path: "/" + route,
        name: "list-" + route,
        component: CrudView,
        meta: { requiresAuth: true },
      },
      {
        path: "/" + route + "/create",
        name: "create-" + route,
        component: CrudView,
        meta: { requiresAuth: true },
      },
      {
        path: "/" + route + "/:uuid",
        name: "edit-" + route,
        component: CrudView,
        meta: { requiresAuth: true },
      },
    ]).concat([
      {
        path: "/",
        redirect: { name: 'towers' },
      },
      {
        path: "/login",
        name: "login",
        component: SignIn,
      },
      {
        path: "/login/callback",
        name: "login-callback",
        component: LoginCallback,
      },
      {
        path: "/towers",
        name: "towers",
        component: TowerList,
        meta: { requiresAuth: true },
      },
      {
        path: "/towers/list?turbine=:turbine&model_number=:model_number",
        name: "towers-list-turbine-model-number",
        component: TowerList,
        meta: { requiresAuth: true },
      },
      {
        path: "/towers/list?turbine=:turbine",
        name: "towers-list-turbine",
        component: TowerList,
        meta: { requiresAuth: true },
      },
      {
        path: "/towers/list",
        name: "towers-list",
        component: TowerList,
        meta: { requiresAuth: true },
      },
      {
        path: "/tower/:uuid/intent",
        name: "tower-intent",
        component: Intent,
        meta: { requiresAuth: true },
      },
      {
        path: "/tower/:uuid/srf",
        name: "tower-srf-plot",
        component: SRFPlot,
        meta: { requiresAuth: true },
      },
      {
        path: "/tower/:uuid/reports",
        name: "tower-reports",
        component: Reports,
        meta: { requiresAuth: true },
      },
      {
        path: "/tower/report-csv-viewer/:filename",
        name: "tower-report-csv-viewer",
        component: ViewCSVReport,
        meta: { requiresAuth: true },
      },
      {
        path: "/profile",
        name: "profile",
        component: UserProfile,
        meta: { requiresAuth: true },
      },
    ]),
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

export default router
